import Carousel from "react-material-ui-carousel";
import { Paper, Button, Container, Box, Typography, Stack } from "@mui/material";

export function ContentRendererBannerCarousel(block: any) {
  return (
    <>
      <Container maxWidth="lg" sx={{ my: 4 }}>
        <Box
          component={Paper}
          elevation={16}
          sx={{
            borderRadius: 2,
            overflow: "hidden",
            height: {
              xs: "300px",
              sm: "400px",
              md: "400px",
              lg: "400px",
            },
          }}
        >
          <Carousel
            indicatorContainerProps={{
              style: {
                position: "absolute",
                bottom: 16,
                zIndex: 2,
              },
            }}
            indicators={!!(block.items.length > 1)}
            sx={{ height: "100%" }}
          >
            {block.items.map((item) => (
              <Box
                key={item.id}
                sx={{
                  height: {
                    xs: "300px",
                    sm: "400px",
                    md: "400px",
                    lg: "400px",
                  },
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundImage: `url(${item.media.data.attributes.url})`,
                  position: "relative",
                }}
              >
                <Box sx={{ position: "absolute", top: 3, p: 3 }}>
                  <Stack direction={"column"} spacing={2}>
                    <Typography color={item.textDark ? "text.primary" : "text.secondary"} variant={"h2"}>
                      {item.title}
                    </Typography>
                    <Typography color={item.textDark ? "text.primary" : "text.secondary"} variant={"h3"}>
                      {item.subtitle}
                    </Typography>
                    <Button href={item.ctaLink} variant="contained" color={item.ctaColor || "primary"}>
                      {item.ctaTitle}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            ))}
          </Carousel>
        </Box>
      </Container>
    </>
  );
}
